import { useLocalObservable } from "mobx-react-lite";
import { createContext, useContext } from "react";

import { AuditFilterStore } from "./audit-filter-store";

export const AuditFilterStoreContext = createContext<AuditFilterStore | null>(null);

export const AuditFilterStoreProvider = ({ children }: { children: React.ReactNode }) => {
  const store = useLocalObservable(() => new AuditFilterStore());
  return (
    <AuditFilterStoreContext.Provider value={store}>{children}</AuditFilterStoreContext.Provider>
  );
};

export const useAuditFilterStore = (): AuditFilterStore => {
  const store = useContext(AuditFilterStoreContext);
  if (!store) {
    throw new Error("useAuditFilterStore must be used within an AuditFilterStoreProvider");
  }
  return store;
};
